import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppMaterial } from './app-material.module';
import { AppRoutingModule } from './app-routing.module';
import { RbFabSpeedDialModule } from 'rb-fab-speed-dial';
import {ScrollingModule} from '@angular/cdk/scrolling';

// import {moment} from 'moment/moment';



import {
  EditorComponent, LearnComponent, PracticeComponent, LoginComponent,
  NavbarComponent, AdminDashboardComponent, AdminProgramLavelComponent,
  CircleComponent, AddCircleComponent, AdminQuestionsComponent, AddIndividualQuestionComponent,
  CampaignListComponent, AddCampaignComponent, AddCodingcafeDialogComponent,
  AddMcqquestionDialogComponent, HackathonComponent, UserListComponent, HackathonQuestionComponent,
  ConfirmComponent, SettingsComponent, NewTestTimeComponent, NewTopicComponent, CampaignDashboardComponent,
  CampaignFunnelComponent, QuestionDifficultyComponent, TestFormatComponent, EditTopicComponent,
  UserListFilterComponent
} from "./components";
import { FlexLayoutModule } from '@angular/flex-layout';
import { AuthServiceConfig, GoogleLoginProvider, SocialLoginModule } from 'angular-6-social-login';
import { HttpService } from './services/http/http.service';
import { LocalstorageService } from './services/localstorage/localstorage.service';
import { HttpClientModule } from '@angular/common/http';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { CodemirrorModule } from 'ng2-codemirror';
import { environment } from "../environments/environment";
import { UtilityService } from './services/utility/utility.service';




import { CampaignComponent } from './components/admin-v2/campaign/campaign.component';
import { DriveComponent } from './components/admin-v2/drive/drive.component';
import { CollegeComponent } from './components/admin-v2/college/college.component';
import { AddInstitutionDialogComponent } from './components/admin-v2/add-institution-dialog/add-institution-dialog.component';
import { OnlineCampaignComponent } from './components/admin-v2/online-campaign/online-campaign.component';
import { AddHiringDriveComponent } from './components/admin-v2/add-hiring-drive/add-hiring-drive.component';
import { AddBranchComponent } from './components/admin-v2/add-branch/add-branch.component';
import { CollegeDetailsComponent } from './components/admin-v2/college-details/college-details.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ClipboardModule } from 'ngx-clipboard';


import { DriveContainerComponent } from './components/admin-v2/drive-container/drive-container.component';
import { DriveAddBranchComponent } from './components/admin-v2/drive-add-branch/drive-add-branch.component';
import { DriveEventComponent } from './components/admin-v2/drive-event/drive-event.component';
import { DriveEventService } from './services/drive-event/drive-event.service';
import { RecentDriveEventComponent } from './components/admin-v2/recent-drive-event/recent-drive-event.component';
import { AccessCodeDialogComponent } from './components/admin-v2/access-code-dialog/access-code-dialog.component';
import { MatDividerModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CampaignSettingComponent } from './components/admin-v2/campaign-setting/campaign-setting.component';
import { AddCompanyComponent } from './components/admin-v2/add-company/add-company.component';
import { TemplateStructureComponent } from './components/admin-v2/template-structure/template-structure.component';
import { UiSwitchModule } from 'ngx-toggle-switch';
import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from "@angular/material-moment-adapter";
import { AttendanceComponent } from './components/admin-v2/attendance/attendance.component';
import { ViewCampaignComponent } from './components/admin-v2/view-campaign/view-campaign.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DownloadXlsxComponent } from './components/admin-v2/download-xlsx/download-xlsx.component';
import { ErrorStatusDialogComponent } from './components/admin-v2/error-status-dialog/error-status-dialog.component';
import { InvitationFormComponent } from './components/admin-v2/registration-form/invitation-form.component';
import { DriveService } from './services/drive/drive.service';
import { AdminService } from './services/admin/admin.service';
import { TemplateService } from './services/template/template.service';
import { ThankYouComponent } from './components/admin-v2/thank-you/thank-you.component';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { SearchPipe } from './services/pipe/search.pipe';
import { InvalidUrlComponent } from './components/admin-v2/invalid-url/invalid-url.component';
import { AddTemplateComponent } from './components/admin-v2/add-template/add-template.component';
import { CampaignDashboardV2Component } from './components/admin-v2/campaign-dashboard-v2/campaign-dashboard-v2.component';
import { DriveDashboardV2Component } from './components/admin-v2/drive-dashboard-v2/drive-dashboard-v2.component';
import { WalkinDriveDialogboxComponent } from './components/admin-v2/walkin-drive-dialogbox/walkin-drive-dialogbox.component';
import { AddResultTemplateComponent } from './components/admin-v2/add-result-template/add-result-template.component';
import { ExcelUploadRegistrationComponent } from './components/admin-v2/excel-upload-registration/excel-upload-registration.component';
import { DownloaddatedialogComponent } from './components/admin-v2/downloaddatedialog/downloaddatedialog.component';


import { ExcelDataComponent } from './components/admin-v2/excel-data/excel-data.component';

export function getAuthServiceConfigs() {
  let config= new AuthServiceConfig(
    [
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(environment.googleClientId)
      }
    ]);
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavbarComponent,
    AdminDashboardComponent,
    EditorComponent,
    LearnComponent,
    PracticeComponent,
    AdminProgramLavelComponent,
    CircleComponent,
    AddCircleComponent,
    AdminQuestionsComponent,
    AddIndividualQuestionComponent,
    CampaignListComponent,
    AddCampaignComponent,
    AddCodingcafeDialogComponent,
    AddMcqquestionDialogComponent,
    HackathonComponent,
    UserListComponent,
    HackathonQuestionComponent,
    ConfirmComponent,
    SettingsComponent,
    NewTestTimeComponent,
    NewTopicComponent,
    CampaignDashboardComponent,
    CampaignFunnelComponent,
    QuestionDifficultyComponent,
    TestFormatComponent,
    EditTopicComponent,
    UserListFilterComponent,
    CampaignComponent,
    DriveComponent,
    CollegeComponent,
    AddInstitutionDialogComponent,
    OnlineCampaignComponent,
    AddHiringDriveComponent,
    AddBranchComponent,
    CollegeDetailsComponent,
    DriveContainerComponent,
    DriveAddBranchComponent,
    DriveEventComponent,
    RecentDriveEventComponent,
    AccessCodeDialogComponent,
    ViewCampaignComponent,
    InvitationFormComponent,
    CampaignSettingComponent,
    AddCompanyComponent,
    TemplateStructureComponent,
    DownloadXlsxComponent ,
    AttendanceComponent,
    TemplateStructureComponent,
    ViewCampaignComponent,
    ErrorStatusDialogComponent,
    ThankYouComponent,
    SearchPipe,
    InvalidUrlComponent,
    AddTemplateComponent,
    AddResultTemplateComponent,
    ExcelUploadRegistrationComponent,
    CampaignDashboardV2Component,
    DriveDashboardV2Component,
    WalkinDriveDialogboxComponent,
    ExcelDataComponent,
    DownloaddatedialogComponent

   
  ],
  imports: [
    BrowserModule,
    AppMaterial,
    AppRoutingModule,
    FlexLayoutModule,
    SocialLoginModule,
    BrowserAnimationsModule,
    HttpClientModule,
    Ng4LoadingSpinnerModule.forRoot(),
    CodemirrorModule,
    RbFabSpeedDialModule,
    UiSwitchModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatDividerModule,
    MatMomentDateModule,
    NgxChartsModule,
    ScrollingModule,
    ClipboardModule,
    NgtUniversalModule,
    
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: getAuthServiceConfigs
    },
    HttpService, LocalstorageService, UtilityService,DriveService,AdminService,TemplateService,
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },

      { provide: MAT_DIALOG_DATA, useValue: {} },
      { provide: MatDialogRef, useValue: {} },

  ],
  entryComponents: [
    AddIndividualQuestionComponent,
    AddCampaignComponent,
    AddCodingcafeDialogComponent,
    AddMcqquestionDialogComponent,
    ConfirmComponent,
    NewTestTimeComponent,
    QuestionDifficultyComponent,
    NewTopicComponent,
    TestFormatComponent,
    EditTopicComponent,
    UserListFilterComponent,
    AddTemplateComponent,
    AddResultTemplateComponent,


    AddInstitutionDialogComponent,
    OnlineCampaignComponent,
    AddBranchComponent,
    AddHiringDriveComponent,

    DriveAddBranchComponent,
    AccessCodeDialogComponent,
    AddCompanyComponent,
    DownloadXlsxComponent,
    ErrorStatusDialogComponent,
    WalkinDriveDialogboxComponent,
    ExcelDataComponent,
    DownloaddatedialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
